/**
 * Service API pour les informations publiques de l'entreprise (FrontOffice)
 * Route publique /api/enterprise/public
 */

import { api, ApiResponse } from '../services/api';

export interface EnterprisePublicInfo {
  name?: string;
  slogan?: string;
  logoUrl?: string;
  email?: string;
  phone?: string;
  address?: {
    city?: string;
    country?: string;
  };
}

export const enterpriseApi = {
  /**
   * Récupérer les informations publiques de l'entreprise
   * GET /api/enterprise/public
   */
  async getPublicInfo(): Promise<ApiResponse<EnterprisePublicInfo>> {
    return api.get<EnterprisePublicInfo>('/api/enterprise/public');
  },
};
